<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="bigdata" title="솔루션" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                AI 빅데이터
            </template>
            <tit-wrap-large class="mb-0">
                <b>AI 빅데이터 농업</b> <br class="d-none d-lg-block" />보다 쉽고 체계적인 미래농업으로 인도합니다.
                <template #text> <b>근권부 빅데이터</b>는 농업에서 혁신적인 아이디어와 솔루션을 제공하는 이레아이에스만의 차별점 입니다. </template>
            </tit-wrap-large>
        </page-section>

        <page-section class="d-flex align-center min-h-lg-980px">
            <div class="page-section__bg" style="background-image:url(/images/sub/solution/bigdata/bigdata-bg.jpg);"></div>
            <div data-aos="fade" data-aos-delay="100">
                <v-divider style="border-color: rgba(255,255,255,0.2)" />
                <div class="py-20px py-md-40px py-xl-80px text-center">
                    <div class="tit-wrap tit-wrap--sm white--text">
                        <h4 class="tit tit--lg">지속가능한 미래농업을 제안하는 AI 빅데이터</h4>
                    </div>
                    <div class="txt txt--xl white--text">이레아이에스는 매일 농가로부터 2억여 건의 데이터를 수집하고 분석하여 작물생산환경에 최적화된 농업 레시피를 제공합니다. <br class="d-none d-lg-block" />인구증가, 기후변화, 물 부족 등으로 다가올 미래 식량위기를 데이터 기반 농업으로 해결할 수 있는 방법을 제안합니다.</div>
                </div>
                <v-divider style="border-color: rgba(255,255,255,0.2)" />
            </div>
        </page-section>

        <page-section-image imageSrc="/images/sub/solution/bigdata/bigdata-img.jpg" reverse>
            <template #title>
                <h4 class="tit tit--lg letter-spacing-n04">보다 더 쉬운 농업의 방식을 제시하는 근권부 AI 빅데이터 솔루션</h4>
            </template>
            <template #text>
                작물의 근권부(뿌리주변)의 정보는 농업에서 우위를 차지하는 차별화된 데이터입니다. 재배환경의 문제를 실시간으로 진단하고 농업인에게 데이터를 기반한 작물의 상태 인지 및 솔루션에 대한 의사결정 대시보드를 제공함으로써 농업 변수의 예측과 대처가 가능해집니다.
            </template>
        </page-section-image>

        <page-section-image class="page-section--last" imageSrc="/images/sub/solution/bigdata/bigdata-img2.jpg">
            <template #title>
                <h4 class="tit tit--lg">편리하고 정확한 데이터 기반 <br class="d-none d-lg-block" />스마트팜 운영</h4>
            </template>
            <template #text>
                10여년간 축적한 근권부 데이터를 활용해 작물의 생장과 생육상태를 모니터링하여 작물의 성장을 최적화 하고 수확량을 높여줍니다. 데이터 농업은 농민을 더 스마트하게 농사를 지을 수 있도록 도와줍니다.
            </template>
        </page-section-image>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import PageSectionImage from "@/pages/client/templates/page-section-image.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        PageSectionImage,
        TitWrapSmall,
        TitWrapLarge,
    },
    props: {},
    data() {
        return {
            tab: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
